/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
// import Button from '@mui/material/Button';
import WidgetDialog from '../components/dialogs';

import TitleHeader from '../components/titleHeader';
import GuideLink from '../components/guidelink';
import ActionLink from '../components/actionlink';
import WaitSpinner from '../components/waitspinner';

import { useStyles } from './styles';
import useWidgetTheme from '../../commons/widgetTheme';
import TranslationIds from '../../commons/translationIds';
import useTranslator from '../../commons/translations';
import getCommonUIStyles from '../../commons/uiStyles';

import useUIStates from '../../store/models/uistates/useUIStates';
import ContentContainer from '../components/contentContainer';

import usePageTransitions from '../../store/models/animations/usePageTransitions';
import {
    TransitionViewNames,
} from '../../store/models/animations/actions/transitions';

import useTranslatedLabels from '../../commons/hooks/useTranslatedLabels';
import useKickstarted from '../../commons/hooks/useKickstarted';

function AlmostDone (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    
    const  {
        translate,
        // translateWithValues,
    } = useTranslator();

    const {
        widget,
        widgetTheme,
    }  = useWidgetTheme();

    const {
        selectedCalendar,
        deviceInfo,
        appStore,
    } = useUIStates();

    const {
        instructions,
    } = useTranslatedLabels();

    const classes = useStyles({
        widget,
        widgetTheme,
        commonUIStyles: getCommonUIStyles({ widgetTheme, widget }),
    });

    usePageTransitions({
        elementName: TransitionViewNames.ALMOST_DONE_VIEW,
        viewAnimation,
    });

    useKickstarted({});
    
    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }

    return (
        <React.Fragment>
            <ContentContainer>
                <WidgetDialog
                    isShowBackButton={false}
                    name={TransitionViewNames.ALMOST_DONE_VIEW}
                    viewAnimation={viewAnimation}
                    initStyles={initStyles}
                >
                    <Grid className={classes.content}>
                        <Grid className={classes.headerSpace}>
                            <TitleHeader
                                widget={widget}
                                widgetTheme={widgetTheme}
                                title={`${translate(TranslationIds.CALENDAR_PROC_TITLE)}`}
                                subtitle={''}
                            />
                        </Grid>

                        <Grid className={classNames([classes.body])}>
                            <Grid
                                className={classes.guide}
                            >
                                <img
                                    alt='guide-banner'
                                    className={classes.guideImage}
                                    src={deviceInfo.guideImage}
                                    data-platform={deviceInfo.dataPlatform}
                                />
                            </Grid>

                            <Grid className={classes.spinnerBox}>
                                <WaitSpinner
                                    visible={true}
                                    commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                                    text={translate(TranslationIds.CALENDAR_PROC_SPINNER)}
                                />
                            </Grid>

                            <Grid className={classNames([classes.bodyMessages])}>
                                {translate(TranslationIds.CALENDAR_PROC_INFO)}&nbsp;
                                {instructions}
                            </Grid>

                            <span className={classes.didntsee}>
                                { translate(TranslationIds.SUCCESS_PAGE_DID_NOT_SEE) }
                                <ActionLink
                                    label={translate(TranslationIds.CALENDAR_PROC_CLICK_HERE)}
                                    commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                                    onClick={() => {
                                        // open the apple popup calendar here...
                                        appStore.openDeviceCalendar(appStore.selectedCalendar.toLowerCase());
                                    }}
                                />
                            </span>
                            
                            <hr className={classes.hr} />

                            <Grid className={classes.help}>
                                { translate(TranslationIds.CALENDAR_PROC_NEED_HELP) }
                                <GuideLink
                                    selectedCalendar={selectedCalendar}
                                    label={translate(TranslationIds.CALENDAR_PROC_GUIDE)}
                                    commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </WidgetDialog>
            </ContentContainer>           
        </React.Fragment>
    );
}

AlmostDone.propTypes = {
    text: PropTypes.string,
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default observer(AlmostDone);